import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useTenantAuth } from "@/context/TenantAuthContext";

export function TenantProtectedRoute() {
  const { tenant } = useTenantAuth();
  if (tenant === null) return <div className="min-h-screen bg-[#0d0d0d]" data-testid="tenant-loading" />;
  if (!tenant) return <Navigate to="/tenant/login" replace />;
  return <Outlet />;
}
